import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';

import { ModalService } from '../../services/modal-service';
import ModalPortal from '../../../components/modal-portal';
import { emptyObject } from 'ui-components/default-props/empty';

const mapifyModals = (currentModals) => Object.keys(currentModals).map((key) => currentModals[key]);

const PortalInstance = ({ id, children, portalProps = emptyObject }) => {
  const onClose = useCallback((isCancel) => ModalService.closeModalById(id, isCancel), [id]);
  const onCancel = useCallback(() => ModalService.closeModalById(id, true), [id]);

  return (
    <ModalPortal key={id} onCancel={onCancel} onClose={onClose} {...portalProps}>
      {children}
    </ModalPortal>
  );
};

PortalInstance.propTypes = {
  children: PropTypes.node.isRequired,
  id: PropTypes.string.isRequired,
  portalProps: PropTypes.object,
};

export const ModalManager = () => {
  const [modals, setModals] = useState(mapifyModals(ModalService.getModals()));

  useEffect(() => {
    const unsubscribe = ModalService.subscribe(() => {
      setModals(mapifyModals(ModalService.getModals()));
    });

    return () => {
      unsubscribe();
      Object.keys(ModalService.getModals()).forEach(ModalService.closeModalById);
    };
  }, []);

  return (
    <>
      {modals.map(({ component: ModalComponent, id, props, portalProps, modalFrameworkMethods, modalProperties }) => (
        <PortalInstance key={id} id={id} portalProps={portalProps}>
          <ModalComponent {...props} modalFrameworkMethods={modalFrameworkMethods} modalProperties={modalProperties} />
        </PortalInstance>
      ))}
    </>
  );
};
